// メインメニューのトップレベル項目に、タイトル文字列を判定して
// header__menu-item--luxury / header__menu-item--japan クラスを付与する。
// Dawnのヘッダーは、子メニューを持つ項目を <a> ではなく
// <header-menu><details><summary> として描画するため、クラスは
// <li>(トップレベル項目全体)に付与し、ラベルは <a> か <summary> の
// どちらからでも取得できるようにする。
document.addEventListener('DOMContentLoaded', function () {
  const topLevelItems = document.querySelectorAll(
    '.header__inline-menu > ul.list-menu--inline > li, .menu-drawer__menu.list-menu > li'
  );

  topLevelItems.forEach(function (item) {
    const label = item.querySelector(':scope > a, :scope > header-menu summary, :scope > details > summary');
    if (!label) return;

    const text = label.textContent.trim();

    if (text.includes('ラグジュアリー') || text.includes('Luxury') || text.includes('ブランド')) {
      item.classList.add('header__menu-item--luxury');
    }

    if (text.includes('日本') || text.includes('Japan') || text.includes('Japanese')) {
      item.classList.add('header__menu-item--japan');
    }
  });
});
